//Search
export const IDI_CUSTOMER_SEARCH_START_LOADING = "IDI_CUSTOMER_SEARCH_START_LOADING";
export const IDI_CUSTOMER_SEARCH_END_LOADING = "IDI_CUSTOMER_SEARCH_END_LOADING";
export const IDI_CUSTOMER_SEARCH_LOADED = "IDI_CUSTOMER_SEARCH_LOADED";
export const SET_IDI_CUSTOMER_FILTER = "SET_IDI_CUSTOMER_FILTER";

//Edit
export const IDI_CUSTOMER_START_LOADING = "IDI_CUSTOMER_START_LOADING";
export const IDI_CUSTOMER_END_LOADING = "IDI_CUSTOMER_END_LOADING";
export const IDI_CUSTOMER_LOADED = "IDI_CUSTOMER_LOADED";
